import React from 'react'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'
/** @jsx jsx */
import { jsx } from 'theme-ui'
import Image from './Image'

const PressList = ({ pressEntries }) => {
  return (
    <>
      {pressEntries.map(({ node }) => {
        return (
          <a
            href={node.pressLink}
            key={node.id}
            sx={{
              textDecoration: `none`,
              color: `text`,
              ':hover': {
                color: `primary`,
              },
            }}
            target="_blank"
            rel="noreferrer noopener"
          >
            <div
              sx={{
                borderBottom: `1px solid`,
                borderColor: `gray.4`,
                display: `grid`,
                gridTemplateColumns: `40px 1fr`,
                alignItems: `center`,
                py: [2, , 3],
              }}
            >
              {node.mediaSource && (
                <div
                  sx={{
                    width: `40px`,
                  }}
                >
                  <Image fluid={node.mediaSource.mediaLogo.asset.gatsbyImageData} />
                </div>
              )}
              <div
                sx={{
                  ml: [3, , 4],
                  // TODO
                  color: node.active || `red`,
                }}
              >
                <div
                  sx={{
                    fontSize: [1],
                    fontWeight: 300,
                  }}
                >
                  {node.releaseDate} - {node.mediaSource.mediaName}
                </div>
                <div>{node.headline}</div>
              </div>
            </div>
          </a>
        )
      })}
    </>
  )
}

export default PressList
